import React from 'react';
import './Footer.css';
import logosMarcas from '../assets/images/logos-footer-blanco.png';

// Sponsors del dentsu Day 2026. Todos se fuerzan a blanco vía CSS para verse
// como un solo sistema sobre el footer oscuro (perdiendo su color de marca),
// excepto Global y Nexus: su isotipo es un bloque de color solido con texto
// adentro, asi que forzarlos a blanco los deja como una caja sin texto
// legible. Esos dos quedan en su color original (keepColor).
const sponsors = [
  { name: 'Página 7', logo: '/images/sponsors/biobio.webp' },
  { name: 'Capsulab', logo: '/images/sponsors/capsulab.webp' },
  { name: 'Cencosud Media', logo: '/images/sponsors/cencosud-media.webp' },
  { name: 'Flesad', logo: '/images/sponsors/flesad.webp' },
  { name: 'Global Vía Pública', logo: '/images/sponsors/global.webp', keepColor: true },
  { name: 'Nexus Media', logo: '/images/sponsors/nexus.webp', keepColor: true },
  { name: 'LatinAd', logo: '/images/sponsors/latinad.webp' },
  { name: 'Logan', logo: '/images/sponsors/logan.webp' },
  { name: 'Massiva', logo: '/images/sponsors/massiva.webp' },
  { name: 'Mediastream', logo: '/images/sponsors/mediastream-2026.webp' },
  { name: 'Micelio', logo: '/images/sponsors/micelio.webp' },
  { name: 'Mowplayer', logo: '/images/sponsors/mowplayer.webp' },
  { name: 'Play', logo: '/images/sponsors/play.webp' },
  { name: 'Publivia', logo: '/images/sponsors/publivia.webp' },
  { name: 'Seedtag', logo: '/images/sponsors/seedtag.svg' },
  { name: 'ShowHeroes', logo: '/images/sponsors/showheroes-2026.webp' },
  { name: 'Voltan', logo: '/images/sponsors/voltan.svg' },
  { name: 'Wortise', logo: '/images/sponsors/wortise.webp' }
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {sponsors.length > 0 && (
            <div className="footer-sponsors-block">
              <p className="footer-sponsors-title">Sponsors</p>
              <div className="footer-sponsors" aria-label="Sponsors">
                <div className="footer-sponsors-track">
                  {[...sponsors, ...sponsors].map((sponsor, index) => (
                    <img
                      key={index}
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className={`footer-sponsor-logo ${sponsor.keepColor ? 'footer-sponsor-logo--color' : ''}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
          <div className="footer-brands">
            <img
              src={logosMarcas}
              alt="dentsu, Carat, Dentsu Creative, dentsu X, iProspect"
              className="footer-brands-img"
            />
          </div>
          <div className="footer-info">
            <p className="footer-title">Dentsu Chile</p>
            <p className="footer-address">
              Badajoz 45, Las Condes, Santiago
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
